import request from '@/utils/requestLogin'

const LANG_KEY = 'language'

const initLang = (() => {
  let lang = window.localStorage.getItem(LANG_KEY)
  return lang || 'lt'
})()

const state = {
  forAccessibility: null,
  systemNotification: null,
  lang: initLang,
}

// getters
const getters = {
  systemNotification: (state) => state.systemNotification,
  getSystemLang: (state) => state.lang,
  getForAccessibility: (state) => state.forAccessibility,
}

// actions
const actions = {
  systemNotification({ commit }, payload) {
    commit('SET_SYSTEM_NOTIFICATION', payload)
  },
  changeLanguage ({ commit }, payload) {
    commit('onLangChanged', payload)
  },
  changeForAccessibility({ commit }, payload) {
    commit('onForAccessibilityChanged', payload)
  },
}

// mutations
const mutations = {
  SET_SYSTEM_NOTIFICATION(state, data) {
    state.systemNotification = data
  },
  onForAccessibilityChanged (state, data) {
    state.forAccessibility = data
  },
  onLangChanged (state, payload) {
    let lang = payload.lang
    if(typeof lang === 'object'){
      lang = lang[0]
    }
    window.localStorage.setItem(LANG_KEY, lang)
    payload.i18n.locale = lang
    state.lang = lang
    if(payload.public) {
      return
    }
    return request({
      url: '/change-language',
      method: 'post',
      data: {
        language: lang
      },
    })
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
